module.exports = __webpack_public_path__ + "assets/img/svip.dd8dff1c.png";